import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { StepData } from '../../../../../../common/components/new-stepper/step-data';
import { TopicsFormValues } from '../../models/topics-form-values';
import { fetchParticipants } from '../participants/demand-detail-participants-actions';

export const DEMAND_DETAIL_TOPICS_SUBMIT = 'DEMAND_DETAIL_TOPICS_SUBMIT';
export const DEMAND_DETAIL_TOPICS_SAVE = 'DEMAND_DETAIL_TOPICS_SAVE';
export const DEMAND_DETAIL_TOPICS_RECEIVED = 'DEMAND_DETAIL_TOPICS_RECEIVED';

export const DEMAND_CONTACT_TOPIC_REGION_COUNT_RECEIVED = 'DEMAND_DETAIL_CONTACT_TOPIC_REGION_COUNT_RECEIVED';

export const submitTopics = (data: StepData<TopicsFormValues>) => ({
    type: DEMAND_DETAIL_TOPICS_SUBMIT,
    data,
});

export const fetchTopics = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const demandId = getState().demandDetail.overview.stepData.values.id;

        if (demandId === undefined) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            return;
        }

        const response = await api.demands.get(demandId);
        if (response.success) {
            dispatch({ type: DEMAND_DETAIL_TOPICS_RECEIVED, demand: response.result });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchContactCountPerTopicAndRegion = (topicIds: number[], regionCodes: string[]) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.demands.getContactCountPerTopicAndRegion(regionCodes, topicIds);

        if (response.success) {
            dispatch({
                type: DEMAND_CONTACT_TOPIC_REGION_COUNT_RECEIVED,
                contactCountPerTopicAndRegion: response.result,
            });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const saveTopics = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const demandId = getState().demandDetail.overview.stepData.values.id;
        const topics = getState().demandDetail.topics.stepData.values.topics ?? [];
        const topicIds = topics.map(topic => topic.id);
        const regions = getState().demandDetail.topics.stepData.values.regions ?? [];
        const regionCodes = regions.map(region => region.code);

        if (demandId === undefined) {
            return false;
        }

        const response = await api.demands.saveTopics(demandId, topicIds, regionCodes);
        if (response.success) {
            fetchParticipants()(dispatch, getState, { api });
        } else {
            return false;
        }

        return true;
    };
};
